<template>

    <question-base :required="answerRequired"
                   :next-button-text="translations.nextButtonText"
                   :back-button-text="translations.backButtonText"
                   :skip-button-text="translations.skipButtonText"
                   :back-button-enabled="this.backButtonEnabled"
                   @skip="skipClicked"
                   @next="nextClicked"
                   @back="backClicked"
                   :button-color="buttonColor"
                   :background-color="backgroundColor"
                   :saving="loading">

        <validation-observer ref="validationObserver" v-slot="{ invalid, errors }">

            <validation-provider
                :name="variable.name"
                :rules="rules"
                mode="lazy"
                v-slot="{ errors }">

                <question-header :question-text="questionText"
                                 :background-color="backgroundColor"
                                 :button-color="buttonColor"
                                 :error-messages="errors">
                </question-header>

                <v-container fluid class="pt-0">

                    <v-row dense>

                        <v-col :cols="twoColumns ? 6 : 12">

                            <v-checkbox v-for="option in optionsColumnOne"
                                        :key="option.id"
                                        v-model="model"
                                        :label="findOptionText(option)"
                                        :value="option.unique_id"
                                        multiple
                                        hide-details
                                        class="mt-0"
                                        :dark="isDarkColor(backgroundColor)"
                                        :error-messages="errors"
                            ></v-checkbox>

                        </v-col>

                        <v-col v-show="twoColumns" cols="6">

                            <v-checkbox v-for="option in optionsColumnTwo"
                                        :key="option.id"
                                        v-model="model"
                                        :label="findOptionText(option)"
                                        :value="option.unique_id"
                                        multiple
                                        hide-details
                                        class="mt-0"
                                        :dark="isDarkColor(backgroundColor)"
                                        :error-messages="errors"
                            ></v-checkbox>

                        </v-col>

                    </v-row>
                </v-container>

            </validation-provider>

        </validation-observer>

    </question-base>
</template>

<script>

import {extend} from 'vee-validate/dist/vee-validate.full';
import QuestionBase from "./QuestionBase";
import questionMixin from "./questionMixin";
import colorMixin from "./colorMixin";
import QuestionHeader from "./QuestionHeader";

export default {

    mixins: [questionMixin, colorMixin],

    components: {
        QuestionHeader,
        QuestionBase
    },

    props: {
        value: {
            type: Array | null,
            required: false,
            default: () => []
        },
    },

    created() {

        extend('min_checks', {

            validate: (value, {min}) => {

                if (!value) return false;

                if (value.length < min) {
                    return false;
                }
                return true;
            },
            params: ['min'],
            message: this.translations.survey_checkbox_min_checks
        });

        extend('max_checks', {

            validate: (value, {max}) => {

                if (!value) return false;

                if (value.length > max) {
                    return false;
                }
                return true;
            },
            params: ['max'],
            message: this.translations.survey_checkbox_max_checks,
        });
    },
}
</script>

